// extracted by mini-css-extract-plugin
export var explainable = "_9g-a";
export var printerCard = "_9g-1";
export var printerCardConfigured = "_9g-2";
export var printerCardError = "_9g-3";
export var printerCardsContainer = "_9g-0";
export var printerIcon = "_9g-8";
export var printerIconConfigured = "_9g-5";
export var printerIconContainer = "_9g-4";
export var printerIconError = "_9g-6";
export var printerIconUnconfigured = "_9g-7";
export var workstationsTableCard = "_9g-9";